
import loader from "../../img/icon_loader.svg";
import "../../css/login.scss";

// エラーメッセージ
const msg = {
  default: 'メールアドレスまたはパスワードが間違っています。',
  code: 'パスコードが間違っています。',
  expired: 'パスコードの期限が切れています。'
};

let Session = {
  apiBaseUrl: '/wp-json/fms/v1/session',
  _session: null,

  _setLoginFlg: false,
  _setLogoutFlg: false,
  _isOIDC: false,
  _tkmURL: null,

  /**
   * 認証状態を取得する
   */
  getAuthStatus: function() {
    return Session._session.type || 0;
  },

  /**
   * ログイン
   */
  _login: function (wrap, btn, ad, pw, err, cd = false, callback = (userKey,roll,type) => {if(userKey != null){ location.reload();}}) {
    Session._setLoginFlg = true;
    const $tgt = $(btn);

    $tgt.on('click', async function (e) {
      e.preventDefault();
      const $form = $(this).closest(wrap);
      const $email = $form.find(ad).val(); // 入力されたメールアドレス
      const $password = $form.find(pw).val(); // 入力されたパスワード
      const $code = cd ? $form.find(cd).val() : ''; // 入力されたパスコード
      const $error_msg = $form.find(err); // エラーメッセージエリア
      const d_btnTxt = $tgt.html(); // ローダー表示から戻す用

      // ローダー表示
      $(this).html(`<img src="${loader}">`);
      try {
        if ($code !== '') {
          // パスコードによるログイン処理
          const results = await $.ajax({
            type: 'POST',
            url: Session.apiBaseUrl + "/login-with-code",
            cache: false,
            data: {
              'email': $email,
              'password': $password,
              'passcode': $code
            },
          });

          const data = results;
          if (data['loginFlag'] === true) {
            callback(data['userKey'],data['role'],data['type']);
            return;
          }

          // パスコード入力済みかつ、パスコードフラグがfalseの場合
          if (data['passCodeExpiredFlag'] !== true) {
            // パスコードが間違っている場合
            $error_msg.text(msg.code);
          } else {
            // パスコードは正しいが期限切れの場合
            $error_msg.text(msg.expired);
          }
        } else {
          const results = await $.ajax({
            type: 'POST',
            url: Session.apiBaseUrl + "/login",
            cache: false,
            data: {
              'email': $email,
              'password': $password,
            },
          });

          const data = results;
          if (data['loginFlag'] === true) {
            callback(data['userKey'],data['role'],data['type']);
            return;
          }

          // パスコード入力済みかつ、パスコードフラグがfalseの場合
          if (data['passCodeExpiredFlag'] !== true) {
            // パスコードが間違っている場合
            $error_msg.text(msg.code);
          } else {
            // パスコードは正しいが期限切れの場合
            $error_msg.text(msg.expired);
          }
          $error_msg.text(msg.default);
        }
        callback(null,null,null);
      } catch (error) {
        callback(null,null,null);
        if (error.responseJSON && error.responseJSON.error) {
          throw new Error(error.responseJSON.error);
        } else {
          throw new Error(error);
        }
      } finally {
        $tgt.html(d_btnTxt);
      }
    });
  },

  /**
   * ログアウト
   */
  _logout: function (tgt, callback = (result) => {if(result === true){ location.reload();}}) {
    Session._setLogoutFlg = true;
    const $tgt = $(tgt);

    $tgt.on('click', async function (e) {
      e.preventDefault();

      try {
        const results = await $.ajax({
          type: 'POST',
          url: Session.apiBaseUrl + "/logout",
          cache: false,
        });

        if (results['success'] === true) {
          callback(results['success']);
        } else {
          callback(false);
        }
      } catch (error) {
        callback(false);
        if (error.responseJSON && error.responseJSON.error) {
          throw new Error(error.responseJSON.error);
        } else {
          throw new Error(error);
        }
      }
    });
  }
}
export default Session;
